<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning">
            <img width="48"
            :src="`${BaseUrl}assets/common/warning.png`"
            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
            <span class="text" v-html="message"></span>
          </div>
          <div class="action text-right">
            <a v-if="showCancel" @click="$emit('close')" class="btn btn-default">{{cancelText}}</a>
            <a @click="$emit('submit')" class="btn btn-primary">{{confirmText}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'WarningModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '確定'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
  },
  watch: {
      message () {
        this.registerHanlink()
      },
    },
  computed: {
    ...mapGetters(['BaseUrl'])
  },
}
</script>
